import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconShareOs: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconShareOs"><Path d="M12 0.585938L17.4142 6.00015L16 7.41436L13 4.41436V14.0002H11V4.41436L8 7.41436L6.58579 6.00015L12 0.585938Z" fill="currentColor"/><Path d="M9.5 9.00015H4V21.0002H20V9.00015H14.5V15.5002H9.5V9.00015Z" fill="currentColor"/></CentralIconBase>;
});

export default IconShareOs;
